/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Use_2_ValueInputs */

const en_svc_research_use_2_value = /** @type {(inputs: Svc_Research_Use_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A market question gets a cited overview in hours instead of a week of tabs.`)
};

const lv_svc_research_use_2_value = /** @type {(inputs: Svc_Research_Use_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirgus jautājums saņem pārskatu ar avotiem dažās stundās, nevis nedēļā pārlūka cilnēs.`)
};

/**
* | output |
* | --- |
* | "A market question gets a cited overview in hours instead of a week of tabs." |
*
* @param {Svc_Research_Use_2_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_use_2_value = /** @type {((inputs?: Svc_Research_Use_2_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Use_2_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_use_2_value(inputs)
	return en_svc_research_use_2_value(inputs)
});